import {
  useSearchParams,
  Navigate,
  useLoaderData,
  useLocation,
} from "react-router-dom"
import myConnections from "../utility/connect"
import useRunOnce from "../customHooks/useRunOnce.js"
import LoadingView from "../views/utilitiesStack/LoadingView"
import { useSelector, useDispatch } from "react-redux"
import { asyncActions as loginAsyncActions } from "../store/slices/loginSlice"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"

const SocialLoginLogic = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const loadingState = useSelector((state) => state.loadingState)
  const isLoading = loadingState.loadingBucket.length > 0

  const [searchParams, setSearchParams] = useSearchParams()

  const code = searchParams.get("code")
  const state = searchParams.get("state")
  const error = searchParams.get("error")
  const error_description = searchParams.get("error_description")

  console.log("=== Social Login Callback Debug ===")
  console.log("Full URL:", window.location.href)
  console.log("Location:", location)
  console.log("Code:", code)
  console.log("State:", state)
  console.log("Error:", error)
  console.log("Error Description:", error_description)
  console.log("All Search Params:", Object.fromEntries(searchParams.entries()))
  console.log("==================================")

  useRunOnce(() => {
    if (error) {
      console.error("Social login error:", error, error_description)
      return
    }

    if (!code) {
      console.error("No code received from social login")
      return
    }

    console.log("Dispatching social login action with:", {
      code,
      type: state,
      navigate: !!navigate,
    })

    dispatch(
      loginAsyncActions.loginWithSocialNetwork({
        code: code,
        type: state,
        navigate: navigate,
      })
    )
  })

  return <div>{isLoading && <LoadingView />}</div>

  // const fetchAccessToken = async (code) => {
  //   const FB_APP_ID = "2240074909657462";
  //   const FB_REDIRECT_URI = "http://localhost:3000/socialNetworkOauth";
  //   const FB_APP_SECRET = "d20ed07611e2933a9136d3fb8799be7f";
  //   try {
  //     const response = await fetch(
  //       `https://graph.facebook.com/v12.0/oauth/access_token?client_id=${FB_APP_ID}&redirect_uri=${FB_REDIRECT_URI}&client_secret=${FB_APP_SECRET}&code=${code}`
  //     );
  //     const data = await response.json();
  //     console.log("Access token response:", data);

  //     if (data.access_token) {
  //       fetchUserData(data.access_token);
  //     } else {
  //       console.error("No access token found in response");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching access token:", error);
  //   }
  // };

  // const fetchUserData = async (accessToken) => {
  //   try {
  //     const response = await fetch(
  //       `https://graph.facebook.com/me?fields=id,name,email&access_token=${accessToken}`
  //     );
  //     const userData = await response.json();
  //     console.log("User data:", userData);
  //   } catch (error) {
  //     console.error("Error fetching user data:", error);
  //   }
  // };

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const code = params.get("code");
  //   console.log("OAuth code:", code); // Log the code for debugging

  //   if (code) {
  //     fetchAccessToken(code);
  //   } else {
  //     console.error("No OAuth code found in URL");
  //   }
  // }, [location]);

  // return (
  //   <>
  //     <h1>BOK</h1>
  //   </>
  // );
}

export default SocialLoginLogic
